// import stimulus-flatpickr wrapper controller to extend it
import Flatpickr from 'stimulus-flatpickr'

// you can also import a translation file
// import { French } from 'flatpickr/dist/l10n/fr.js'
// import { english } from "flatpickr/dist/l10n/default.js";

// import a theme (could be in your main CSS entry too...)
// import 'flatpickr/dist/themes/dark.css'

// create a new Stimulus controller by extending stimulus-flatpickr wrapper controller
export default class extends Flatpickr {
  // locales = {
  //   fr: French,
  //   en: english
  // };
    
  // initialize() {
  //   // sets your language (you can also set some global setting for all time pickers)
  //   this.config = {
  //     enableTime: true,
  //     locale: this.locale,
  //     altInput: true,
  //     dateFormat: "D m/d/y, h:iK",
  //     defaultDate: "today",
  //     maxDate: "today"
  //   }
  // }

  // all flatpickr hooks are available as callbacks in your Stimulus controller
  // change(selectedDates, dateStr, instance) {
  //   console.log('the callback returns the selected dates', selectedDates)
  //   console.log('but returns it also as a string', dateStr)
  //   console.log('and the flatpickr instance', instance)
  // }
  
  // get locale() {
  //   if (this.data.has("locale")) {
  //     return this.locales[this.data.get("locale")];
  //   }
  // }

  // ready(dObj, dStr, fp, dayElem){
    // console.log('Ready!')
    // console.log(fp.config.enableTime)
    // console.log(fp.amPM.innerHTML)
    // console.log(fp.hourElement.attributes.min.value)
    // fp.hourElement.attributes.min.value = 5 || 1
    // console.log(fp)
    // console.log("#{Rails.application.client.shifts_configuration.round_time_to_nearst_quarter_hour_enabled}")
    // if(fp.config.enableTime && config_is_set){
    //   if(fp.amPM.innerHTML == 'AM'){
    //     fp.hourElement.attributes.min.value = 5
    //   } else {
    //     fp.hourElement.attributes.min.value = 1
    //   }
    // }
  // }
}
